// Actiondan gelen datalar ile stateler güncellenecek
export const userLoading = (state, payload) => {
    state.loading = payload
}

export const userStatus = (state, payload) => {
    state.userStatus = payload
}

export const getUser = (state, payload) => {
    state.users = payload.data ? payload.data : payload
    state.userPageInfo = payload.list_info
}

export const login = (state, payload) => {
    if(payload.data)
        state.login = payload.data
    else
    state.login = payload
}

export const getUserMenu = (state, payload) => {
    state.menus = payload.data ? payload.data : payload
}

export const getAuth = (state, payload) => {
    state.auth = payload.data ? payload.data : payload
}

export const getUserType = (state, payload) => {
    state.types = payload.data ? payload.data : payload
}

export const getLogs = (state, payload) => {
    if(payload.data){
        state.logs = payload.data
    }
    state.logsPageInfo = payload.list_info
}

export const userDetail = (state, payload) => {
    if(payload.data){
        state.user = payload.data
    }
}
export const authCasbin = (state, payload) => {
    if(payload.data){
        state.authCasbin = payload.data
    }
}
export const authsCasbin = (state, payload) => {
    state.authsCasbin = payload.data ? payload.data : []
}
export const getAuthMenu = (state, payload) => {
    if(payload.data){
        state.authMenus = payload.data
    }else{
        state.authMenus = []

    }
}

export const widgets = (state, payload) => {
    if(payload.data){
        state.widgets = payload.data
    }else{
        state.widgets = []
    }
}

export const widgetVal = (state, payload) => {
    if(Array.isArray(payload.res.data)){
        let bData = state.widgetVal.findIndex(e => e.key == payload.key);
        console.log(bData, payload)
        if(bData>=0){
            state.widgetVal[bData].value = payload.res.data
        }else{
            state.widgetVal.push({key:payload.key, value: payload.res.data})
        }
    }else{
        let bData = state.widgetVal.findIndex(e => e.key == payload.res.data.key);
        if(bData>=0){
            state.widgetVal[bData].value = payload.res.data.value
        }else{
            state.widgetVal.push(payload.res.data)
        }
    }
}




// WEBPACK FOOTER //
// ./src/store/modules/Users/Mutaions.js